import { ListOfServicesCategories } from "./ServicesCategories.types";

import { IMessageBar } from "@/core/libs/message-bar";

export enum ServicesCategoriesActionsTypes {
  CREATE_REQUEST = "services-categories/CREATE_REQUEST",
  CREATE_FAIL = "services-categories/CREATE_FAIL",
  CREATE_SUCCESS = "services-categories/CREATE_SUCCESS",
  DISMISS_MESSAGE = "services-categories/DISMISS_MESSAGE",
  EDIT_REQUEST = "services-categories/EDIT_REQUEST",
  EDIT_FAIL = "services-categories/EDIT_FAIL",
  EDIT_SUCCESS = "services-categories/EDIT_SUCCESS",
  LIST_REQUEST = "services-categories/LIST_REQUEST",
  LIST_FAIL = "services-categories/LIST_FAIL",
  LIST_SUCCESS = "services-categories/LIST_SUCCESS"
}

export interface ServicesCategoriesState {
  isLoadingList: boolean;
  list?: ListOfServicesCategories;
  message?: IMessageBar;
}

interface CreateRequest {
  type: ServicesCategoriesActionsTypes.CREATE_REQUEST;
}

interface CreateError {
  type: ServicesCategoriesActionsTypes.CREATE_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface CreateSuccess {
  type: ServicesCategoriesActionsTypes.CREATE_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface DismissMessage {
  type: ServicesCategoriesActionsTypes.DISMISS_MESSAGE;
}

interface EditRequest {
  type: ServicesCategoriesActionsTypes.EDIT_REQUEST;
}

interface EditError {
  type: ServicesCategoriesActionsTypes.EDIT_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface EditSuccess {
  type: ServicesCategoriesActionsTypes.EDIT_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface ListRequest {
  type: ServicesCategoriesActionsTypes.LIST_REQUEST;
}

interface ListError {
  type: ServicesCategoriesActionsTypes.LIST_FAIL;
}

interface ListSuccess {
  type: ServicesCategoriesActionsTypes.LIST_SUCCESS;
  payload: {
    list: ListOfServicesCategories;
  };
}

export type ServicesCategoriesReducerActions =
  | CreateRequest
  | CreateError
  | CreateSuccess
  | DismissMessage
  | EditRequest
  | EditError
  | EditSuccess
  | ListRequest
  | ListError
  | ListSuccess;
